export default "__VITE_ASSET__DsBllO$b__"